import { Params } from 'react-router-dom'

import { api } from '@api'
import { ApiParams, Carrier, ContractsOrdersResponse, OrdersFilters } from '@types'

const base = '/sap-items'

interface GetCarriersResponse {
  carriers: { carriers: Carrier[] }
}

interface FilteredCarriersResponse {
  carriers: Carrier[]
  total: number
}

interface GetFilteredCarriersResponse {
  carriers: FilteredCarriersResponse
}

type OrdersParams = {
  filters?: OrdersFilters
}

export interface Form {
  carrierId: number
  category?: number
  enabledForAlgorithm?: boolean
}

const getCarriers = async () => {
  const response = await api.get<GetCarriersResponse>('/carriers')

  return response.data.carriers.carriers
}

const getCarriersFilter = async (params: Params) => {
  const { filters } = params
  const response = await api.get<FilteredCarriersResponse>(base + '/filters', {
    params: filters,
  })

  return response.data
}

const getCarriersWithFilters = async ({ filters }: ApiParams) => {
  const response = await api.get<GetFilteredCarriersResponse>('/carriers', {
    params: {
      ...filters,
    },
  })

  return response.data.carriers
}

const changeOptions = async (payload: Form) => {
  const { carrierId, ...restOfValues } = payload
  const response = await api.put<GetCarriersResponse>(`/carriers/${carrierId}`, {
    carrier: restOfValues,
  })

  return response.data
}

const getContractOrders = async (params: OrdersParams) => {
  const { filters } = params
  const { carrierId, contract, orderNumber, page, limit, ...restFilters } = filters || {}

  const paramsToSend: any = {
    page,
    limit,
    ...restFilters,
  }

  if (carrierId) {
    if (Array.isArray(carrierId)) {
      paramsToSend.carrierId = carrierId
    } else {
      paramsToSend.carrierId = [carrierId]
    }
  }

  if (contract) {
    paramsToSend.contract = contract.toString()
  }

  if (orderNumber) {
    paramsToSend.orderNumber = orderNumber
  }

  const response = await api.get<ContractsOrdersResponse>('carriers/contract-order', {
    params: paramsToSend,
  })
  return response.data
}

export const CarriersApi = {
  getCarriers,
  getCarriersWithFilters,
  changeOptions,
  getCarriersFilter,
  getContractOrders,
}
